export default "__VITE_ASSET__D3vS93jg__"